export default __webpack_public_path__ + "static/media/SndLowerSLittleMagicC.b9210add.mp3";